import { render, staticRenderFns } from "./2FA.vue?vue&type=template&id=66505c64&scoped=true&"
import script from "./2FA.vue?vue&type=script&lang=js&"
export * from "./2FA.vue?vue&type=script&lang=js&"
import style0 from "./2FA.vue?vue&type=style&index=0&id=66505c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66505c64",
  null
  
)

export default component.exports